// ** Third Party Components
import { Check, Download, Edit, Edit2, Eye, Info, Trash, X } from 'react-feather'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Spinner } from 'reactstrap'
import toast from 'react-hot-toast'

import { Icon } from '@iconify/react'
import { setOpenModal } from '../store'
// ** Table Common Column

const SERVICES_DIGITAL_SIGNATURE = {
  '01': 'Api de Firma',
  '02': 'Portal completo'
}

const SERVICE_DIGITAL_FACTURA = {
  '01': 'Api de Facturación',
  '02': 'Portal de consultas',
  '03': 'Portal completo'
}

const CustomActions = ({ row }) => {
  const dispatch = useDispatch()

  const handleDelete = () => {
    console.log("ROW: ", row.id)
    return dispatch(setOpenModal({ type: 'delete', open: true, data: row.id }))

  }

  const handleEdit = () => {
    return dispatch(setOpenModal({ type: 'edit', open: true, data: row }))
  }

  return (
    <div className="d-flex align-items-center justify-content-center gap-1">
      <>
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          onClick={handleEdit}
          color="primary"
        >
          <Edit />
        </Button>
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          color="danger"
          onClick={handleDelete}
        >
          <Trash />
        </Button>
      </>
    </div>
  )
}

export const columns2 = () => [
  {
    name: 'Cliente',
    width: '9%',
    // center: true,
    selector: (row) => row.receiverName,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">{row.receiverName}</div>
    )
  },
  {
    name: 'Nombre comercial',
    width: '9%',
    // center: true,
    sortable: true,
    selector: (row) => row?.tradeName
  },
  {
    name: 'Documento',
    width: '9%',
    // center: true,
    sortable: true,
    selector: (row) => (row?.typeEntity?.value === "N" ? "DUI" : "NIT")
  },
  {
    name: 'N° documento',
    width: '9%',
    // center: true,
    sortable: true,
    selector: (row) => (row?.typeEntity?.value === "N" ? row.DUI: row.NIT)
  },
  {
    name: 'Departamento',
    width: '9%',
    sortable: true,
    // center: true,
    selector: (row) => row?.department?.label
  },
  {
    name: 'Municipio',
    width: '9%',
    // center: true,
    sortable: true,
    selector: (row) => row?.municipality?.label
  },
  {
    name: 'Dirección',
    width: '9%',
    // center: true,
    sortable: true,
    selector: (row) => row?.address
  },
  {
    name: 'Actividad económica',
    width: '9%',
    center: true,
    cell: (row) => row?.EconomicActivity?.label
  },
  {
    name: 'Correo electrónico',
    width: '10%',
    center: true,
    cell: (row) => row?.receiverEmail
  },
  {
    name: 'Teléfono',
    width: '9%',
    center: true,
    cell: (row) => row?.receiverPhoneNumber
  },
  {
    name: 'Acciones',
    width: '9%',
    // center: true,
    selector: '',
    cell: (row) => <CustomActions row={row} />
  }
]

export const columns = () => [
  {
    name: 'Id',
    width: '11%',
    center: true,
    selector: row => row.id,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.id}
      </div>
    )
  },
  {
    name: 'Tipo de producto',
    width: '11%',
    center: true,
    selector: row => row.prodType.value,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.prodType.label}
      </div>
    )
  },
  {
    name: 'Código',
    width: '11%',
    center: true,
    selector: row => row.productCode,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.productCode}
      </div>
    )
  },
  {
    name: 'Nombre',
    width: '11%',
    center: true,
    selector: row => row.productName,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.productName}
      </div>
    )
  },
  {
    name: 'Descripción',
    width: '11%',
    center: true,
    selector: row => row.description,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.description}
      </div>
    )
  },
  {
    name: 'Unidad de medida',
    width: '11%',
    center: true,
    selector: row => row.unitOfMeasure.label,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.unitOfMeasure.label}
      </div>
    )
  },
  {
    name: 'Precio',
    width: '11%',
    center: true,
    selector: row => row.price,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        $ {parseFloat(row?.price).toLocaleString('en-US')}
      </div>
    )
  },
  {
    name: 'Estado',
    width: '11%',
    center: true,
    selector: row => row.isActive,
    sortable: true,
    cell: (row) => (row.isActive ? 'Activo' : 'Inactivo')
  },
  {
    name: 'Acciones',
    width: '11%',
    center: true,
    allowOverflow: true,
    cell: (row) => <CustomActions row={row} />
  }
]
